<template>
  <div>
    <Modal v-model="modalSwitch" :width="width" :mask-closable="false" @on-visible-change="changeV" @on-close="modal_cancel">
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box"/>
        <span>{{titleName}}</span>
      </p>
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="modal_cancel"></i>
      <div class="sc-content-wrapper">
        <div class="search-wrapper">
          <input type="text" placeholder="关键字" v-model="keyword" @keyup.enter="searchDo" />
          <button @click="searchDo" class="i">搜索</button>
        </div>
        <div class="inner-content-wrapper">
          <div class="choice-box-wrapper">
          <slot name="choice"></slot>
        </div>
          <div class="page-wrapper">
            <Page
              :total="Tpage.totalAmount"
              show-total
              :current="Tpage.currentPage"
              :page-size="Tpage.currentSize"
              @on-change="changePage"
              size="small"
            />
          </div>
          <Table :row-class-name="rowClassName" size="small" disabled-hover :loading="loading" ref="currentRowTable" :columns="columnsFormatData" :data="main_data" @on-row-click="chooseOne"></Table>
          <div class="page-wrapper">
            <Page
              :total="Tpage.totalAmount"
              :current="Tpage.currentPage"
              :page-size="Tpage.currentSize"
              @on-change="changePage"
              show-elevator
              size="small"
            />
          </div>
        </div>
        
      </div>
      <div slot="footer">
        <Button size="large" @click="modal_save" :disabled="ifValid" >确定</Button>
        <Button size="large" @click="modal_cancel" >关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
  name: "singleSelector",
  props: {
    dataUrl: {
      type: String,
      default: "/ask_list_data"
    },
    width: {
      type: String,
      default: "800"
    },
    modalSwitch: {
      type: Boolean,
      required: true
    },
    titleName: {
      type: String,
      default: "请选择"
    },
    askData: {
      type: String,
      default: ""
    },
    columnsFormatData:{
        type:Array,
        required:true,
    },
  },
  mixins: [],
  data() {
    return {
      no_data_text: "暂无数据",
      Tpage: {
        currentPage: 1,
        totalAmount: 0,
        currentSize: 8
      },
      main_data: [],
      loading: false,
      currentChoosed: null,
      keyword: "",
    };
  },
  computed: {
    ifValid() {
      return this.currentChoosed === null;
    },
  },
  mounted() {
    if(this.modalSwitch){
      this.get_data();
    }
  },
  methods: {
    chooseOne(currentValue){
      this.currentChoosed = currentValue;
    },
    changePage(value) {
      this.Tpage.currentPage = value;
      this.get_data();
    },
    get_data() {
      this.loading = true;
      this.$axios
        .post(this.$url + this.dataUrl, {
          selected_list:[],
          page:this.Tpage,
          userToken: userToken,
          optionData: {
            name:'',
            catagory:'',
            sub_catagory:'',
            position_A:'',
            position_B:'',
            keyword:this.keyword,
            order:'',
            esc:'esc'
          },//关键字匹配哪一列由后端代码决定
          ask_data: this.askData
        })
        .then(
          response => {
            if(response.data.stat==='ok'){
              this.main_data = response.data.res_record;
              this.loading = false;
              this.Tpage.totalAmount = response.data.total_n;
            }else{
              this.$Message.error('请求数据错误！');
            }
          }
        )
        .catch(error=>{
          this.$Message.error("服务器连接失败！请确认网络是否连接～"+error)
        }
        );
    },
    searchDo() {
      this.get_data();
    },
    modal_cancel() {
      this.$refs.currentRowTable.clearCurrentRow();
      this.currentChoosed = null;
      this.keyword = "";
      this.$emit("closeModal", false);
    },
    modal_save() {
      this.$emit("confirmResult", this.currentChoosed);
      this.$refs.currentRowTable.clearCurrentRow();
      this.currentChoosed = null;
    },
    modal_add() {
        this.$emit("addResult",this.currentChoosed);
    },
    changeV(value){
      if(value){
        this.get_data();
      }
    },
    rowClassName(row) {
        if (this.currentChoosed!==null&&this.currentChoosed.id === row.id) {
            return "choosed-style";
        } else{
            return '';
        }
    },
    // modal_del(){
    //   this.loading = true;
    //   this.$axios
    //     .post(this.$url + '/del_from_modal', {
    //       userToken: userToken,
    //       value: this.main_data[this.selected_index].id,
    //       askData: 'modelDel'
    //     })
    //     .then(
    //       response => {
    //         if(response.data.stat==='ok'){
    //           this.$Message.success("删除成功！");
    //           this.selected_index = null;
    //           this.get_data();
    //         }else{
    //           this.$Message.error('请求数据错误！');
    //         }
    //       }
    //     )
    //     .catch(error=>{
    //       this.$Message.error("服务器连接失败！请确认网络是否连接～"+error)
    //     }
    //     );
    // },
  },
  
};
</script>
<style scoped>
.sc-content-wrapper {
  padding: 5px 30px 0 30px;
  
}
.sc-wrapper {
  border: 1px solid #ccc;
  padding: 10px 20px;
  cursor: pointer;
  margin-bottom: 10px;
}
.sc-one-content {
  margin: 0 10px;
  font-size: 14px;
  line-height: 28px;
}
.a{
  background: url("~@/assets/img/choose.png") right bottom no-repeat;
}

input {
  border: 1px solid #aaa;
  height: 40px;
  padding: 10px 10px;
  width: 300px;
}

input:focus {
  outline: none;
  border: 1px solid #333;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ddd;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ddd;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ddd;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ddd;
}

button.i {
  border: none;
  outline: none;
  background: #993333;
  color: #ddd;
  height: 40px;
  width: 100px;
  text-align: center;
  letter-spacing: 8px;
  text-indent: 8px;
  font-size: 14px;
  position: relative;
  top: 1px;
  cursor: pointer;
}

button.i:hover {
  color: #fff;
}

.search-wrapper {
  text-align: center;
}

.inner-content-wrapper {
  margin: 10px 0;
  padding: 10px 0;
  position: relative;
}
.no-find {
  text-align: center;
}
.ele-span {
  margin-right: 15px;
}

.confirm-button,
.cancel-button {
  border-radius: 2px;
}

.cancel-button {
  background: #571d1d;
}

.page-wrapper {
  text-align: right;
  padding: 5px;
}

.ivu-icon-ios-close {
    font-size: 31px;
    color: #999;
    transition: color .2s ease;
    position: relative;
    top: 1px;
}
.ivu-icon-ios-close:before {
    content: "\F178";
}

.del-button{
  float:left;
}
.choice-box-wrapper{
  position: absolute;
  left:5px;
  top:5px;
}
</style>